<template>
  <div
     class="nuttrema-menu-list"
    :class="[`theme-${theme}`]"
    :style="styleProps">
    <slot>
      <div class="nuttrema-menu-list__vertical">
        <div class="vertical__top">
          <slot name="vertical-top"></slot>
        </div>
        <div class="vertical__center">
          <slot name="vertical-center"></slot>
        </div>
        <div class="vertical__bottom">
          <slot name="vertical-bottom"></slot>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-menu-list',
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: 'regular',
    },
    styleProps: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/theme/person-colors";

  .nuttrema-menu-list {
    display: flex;
    position: relative;
    flex-direction: column;
    flex-shrink: 0;

    section {
      margin-bottom: 0.5em;
    }

    .nuttrema-menu-list__vertical {
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      flex-direction: column;
      justify-content: space-between;
      .vertical__top {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        overflow-y: auto;
        justify-content: flex-start;
      }
      .vertical__bottom {
        margin-top: 0.5em;
      }
    }

    &.in-collapsed {
      .is-expanded & {
        display: none;
      }
    }

    &.theme-popover-nav {
      /deep/ .list-item-label {
        font-weight: 600;
        padding-left: 12px;
        width: 100%;
      }
      /deep/ section {
        margin: 0;
        margin-bottom: 1em;
        margin-right: -0.75em;

        &:last-child {
          margin-bottom: 0;
        }

        .nuttrema-menu-list-item {
          .list-item-link {
            display: flex;
            padding-left: 8px;
            align-self: stretch;
            flex-direction: column;
            flex-grow: 1;

            > span {
              flex-grow: 1;
              display: flex;
              align-items: center;
              align-self: stretch;

              font-weight: 400;
              padding-left: 4px;
              font-size: 0.95em;
              line-height: 2.4em;
              color: $gray-light;
              border-bottom: 1px solid $gray-lighter;

              i {
                display: flex;
                margin-right: 0.5em;
              }
            }

            > .is-control {
              flex-grow: 1;
              display: flex;
              align-items: center;
              align-self: stretch;
              padding: 0 0.5em 0 0.3em;
              justify-content: space-between;
              border-bottom: 1px solid $gray-lighter;

              span {
                font-weight: 400;
                line-height: 2.4em;
                font-size: 0.95em;
                color: $gray-light;
              }
            }


            &:hover, &:focus, &:active, &.is-active {
              border-top-left-radius: 0.5em;
              background-color: darken($gray-lighter, 5%);
              border-bottom-left-radius: 0.5em;
              > span {
                border-color:  $gray-lighter;
              }
            }

            &.is-active {
              background-color: $primary-color;
              > span {
                color: #fff;
                border-top: 1px solid $primary-color !important;
                border-bottom: 1px solid $primary-color !important;
              }
            }

            &.is-lock {
              background-color: $gray-light;
              border-top-left-radius: 0.5em;
              border-bottom-left-radius: 0.5em;
              margin-bottom: 1px;
              > span {
                color: #fff;
                border-top: none !important;
                justify-content: space-between;
                border-bottom: 1px solid $gray-light !important;
              }
            }

            > .nuttrema-menu-list {
              margin: 0.5em 0;
              /deep/ .nuttrema-menu-list-item {
                .list-item-link {

                  > span {
                    color: $gray-light;
                    flex-direction: row;
                    align-items: center;
                    i {
                      display: flex;
                      margin-right: 0.5em;
                    }
                  }

                  &:hover, &:focus, &:active, &.is-active {
                    background-color: darken($gray-lighter, 5%);
                  }

                  &.is-active {
                    background-color: $gray-lighter;
                    > span {
                      color: $gray-light;
                      background-color: $gray-lighter;
                      border-top: 1px solid $gray-lighter !important;
                      border-bottom: 1px solid $gray-lighter !important;
                    }
                  }
                }
                &:last-child {

                    .list-item-link > span {
                      border-bottom: none !important;
                    }

                }
              }
            }
          }

          &:first-child {
            .list-item-link {
              > span {
                border-top: 1px solid $gray-lighter;
              }
            }
          }
        }
      } // end ~ section

      &.is-popover-collapse {
        /deep/ section {
          .nuttrema-menu-list-item {
            &:first-child {
              .list-item-link {
                > span {
                  border-top: none;
                }
              }
            }
            &:last-child {
              .list-item-link {
                > span {
                  border-bottom: none;
                }
              }
            }
          }
        }
      }

      &.is-user-menu {
        flex-grow: 1;
        margin-top: 0.5em;

        /deep/ .vertical__bottom {
          margin: 1em;
        }

        /deep/ .list-item-label {
          padding-left: 1.5em;
        }

        /deep/ section {
          margin-left: 0;
          margin-right: 0.5em;
          margin-bottom: 1em;
          .nuttrema-menu-list-item {
            .list-item-link {
              line-height: 2.8em;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-top-right-radius: 0.5em;
              border-bottom-right-radius: 0.5em;
              padding-right: 0.5em;
              .nuttrema-menu-list {
                margin-left: -0.5em;
              }
            }
            &:first-child {
              .list-item-link {
                > span {
                  border-top: 1px solid $gray-lighter;
                }
              }
            }
          }
        }

        @mixin section-desktop() {
          /deep/ section {
            margin-left: 0.5em;
            margin-right: 0;
            .nuttrema-menu-list-item {
              .list-item-link {
                padding-right: 0;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                border-top-left-radius: 0.5em;
                border-bottom-left-radius: 0.5em;
                .nuttrema-menu-list {
                  margin-left: 0;
                }
              }
            }
          }
        }

        .is-for-desktop &, .is-for-big-desktop & {
          @include section-desktop;
        }

        @media (min-width: 1200px) {
          @include section-desktop;
        }
      }

      &.is-white {
        /deep/ .list-item-label {
          color: #fff;
        }
        /deep/ section {
          .nuttrema-menu-list-item {
            .list-item-link {
              > span {
                color: #fff;
                &:hover, &:focus {
                  color: $primary-color;
                }
              }

              &:active, &.is-active {
                margin-top: -1px;
                background-color: #fff;
                > span {
                  font-weight: 500;
                  color: $primary-color;
                  border-top: 1px solid #fff !important;
                  border-bottom: 1px solid #fff !important;
                }
              }

              .list-item-link {
                > span {
                  color: $gray-light;
                }

                &:active, &.is-active {
                  background-color: $gray-lighter;
                  > span {
                    color: $gray-light;
                    border-top: 1px solid $gray-lighter !important;
                    border-bottom: 1px solid $gray-lighter !important;
                  }
                }
              }
            }
          }
        }
      }

      &.is-male {
        /deep/ section .nuttrema-menu-list-item .list-item-link {
          &:active, &.is-active, &:hover, &:focus { > span { color: $male-gradient-from; } }
        }
      }

      &.is-female {
        /deep/ section .nuttrema-menu-list-item .list-item-link {
          &:active, &.is-active, &:hover, &:focus { > span { color: $female-gradient-from; } }
        }
      }

    } // end ~ theme-popover-nav

    &.theme-sidebar-menu {
      /deep/ .nuttrema-menu-list-item {
        margin-bottom: 0.15em;
      }
    }

    &.theme-options-list {
      section {
        .section-title {
          width: 100%;
          font-size: 1rem;
          margin-bottom: 0;
          font-weight: 500;
          border-bottom: 1px solid #DBE2EF;
          padding: 1em 0.75em 0.15em 0.75em;
        }

        .section-items {
          background-color: #fff;
          border-bottom: 1px solid #DBE2EF;
        }

        /deep/ .nuttrema-menu-list-item {
          display: flex;
          flex-shrink: 0;
          color: #555555;
          align-self: stretch;
          align-items: center;
          padding: 0.5em 0.75em;
          background-color: #fff;
          justify-content: space-between;
          border-bottom: 1px solid #DBE2EF;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            cursor: pointer;
            background-color: rgba(#ffdd57, 0.25);
          }

          .nuttrema-menu-list-item__icon {
            display: flex;
            flex-shrink: 0;
            margin-right: 0.75em;
          }

          .nuttrema-menu-list-item__title {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-right: 0.75em;
            > span {
              height: 1.5em;
              font-weight: 500;
            }
          }

          .nuttrema-menu-list-item__action {
            display: flex;
            flex-shrink: 0;
          }
        }
      }
    } // end ~ theme-options-list

    .nuttrema-theme-professional-topography & {
      $topography-bg: #00bcd4;
      /deep/ section {
        .nuttrema-menu-list-item {
          .list-item-link {
            &.is-active {
              background-color: $topography-bg;
              > span {
                color: #fff;
                border-top: 1px solid $topography-bg !important;
                border-bottom: 1px solid $topography-bg !important;
              }
            }
          }
        }
      }
    }
    // end ~ .nuttrema-theme-professional-topography...

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/navigation/nuttrema-menu-list.vue